import { Button } from '@bfe/moly';
import { FC } from 'react';

import ByModal from '@/components/ByModal';
import { useI18nContext } from '@/i18n/I18n';

interface IConfirmModalProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  content?: React.ReactNode;
  title?: React.ReactNode;
  showCancelBtn?: boolean;
  okBtnText?: string;
  cancelBtnText?: string;
  confirmDisabled?: boolean;
}
export const ConfirmModal: FC<IConfirmModalProps> = (props) => {
  const [$t] = useI18nContext();
  const {
    isVisible,
    title,
    content,
    okBtnText = $t('Confirm'),
    cancelBtnText = $t('Cancel'),
    showCancelBtn = false,
    onCancel,
    onConfirm,
    confirmDisabled = false,
  } = props;

  return (
    <ByModal visible={isVisible} title={title} onCancel={onCancel} width={480}>
      <div>{content}</div>
      <div style={{ display: 'flex', gap: 24 }}>
        <Button
          variant="primary"
          size="large"
          style={{ marginTop: 24, height: 48 }}
          onClick={onConfirm}
          disabled={confirmDisabled}
          block
        >
          {okBtnText}
        </Button>
        {showCancelBtn && (
          <Button
            style={{ marginTop: 24 }}
            onClick={onCancel}
            variant="secondary"
            block
          >
            {cancelBtnText}
          </Button>
        )}
      </div>
    </ByModal>
  );
};
